import { createSelector } from 'reselect';
import { getArmy } from '@Selectors/user/selector/army.get';
import { allConstraintableElement } from '@Selectors/builder/myArmyList/common/constraints/elements/constrainable/all-constraintable-element';
import { getArmyList } from '@Selectors/builder/myArmyList/make/unit/edit/selector/editSelector';
import { ConstrainedObject } from '@Models';

export const constrainedOjectsPresenter = createSelector(
  [getArmy, getArmyList],
  (army, armyList): ConstrainedObject[] => {
    return allConstraintableElement(army, armyList);
  },
);
